import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Divider, Button, CircularProgress, Alert } from '@mui/material';
import Navbar from '../Layouts/Navbar';
import { Person } from '@mui/icons-material';
import { Edit } from '@mui/icons-material';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import api from '../../utils/api';
import { getCurrentUser } from '../../utils/auth';
import { format } from 'date-fns';




export default function AdminCompte() {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [societe, setSociete] = useState(null);

  // Helper function to format dates
  const formatDate = (dateString) => {
    if (!dateString) return 'Non disponible';
    try {
      return format(new Date(dateString), 'dd/MM/yyyy');
    } catch (error) {
      console.error('Error formatting date:', error);
      return dateString;
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      try {
        // Get current user from localStorage
        const currentUser = getCurrentUser();
        if (!currentUser || !currentUser.ID_User) {
          throw new Error('User not authenticated or ID not found');
        }

        // Fetch user data from API
        const response = await api.get(`/users/${currentUser.ID_User}`);
        setUserData(response.data);
        console.log(response.data)

        // If user has site data with ID_Societe, fetch societe data
        if (response.data.site && response.data.site.ID_Societe) {
          try {
            const societeResponse = await api.get(`/societes/${response.data.site.ID_Societe}`);
            setSociete(societeResponse.data);
          } catch (err) {
            console.error(`Error fetching societe:`, err);
          }
        }

        setError(null);
      } catch (err) {
        console.error('Error fetching user data:', err);
        setError('Failed to load user data. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  if (loading) {
    return (
      <>
        <Navbar />
        <Box display="flex" justifyContent="center" alignItems="center" height="80vh">
          <CircularProgress />
        </Box>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Navbar />
        <Box p={3}>
          <Alert severity="error">{error}</Alert>
        </Box>
      </>
    );
  }

  if (!userData) {
    return (
      <>
        <Navbar />
        <Box p={3}>
          <Alert severity="warning">No user data available.</Alert>
        </Box>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <Box p={3}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between">
            <Box display="flex" alignItems="center">
          <Person />
          <Typography variant="h6" ml={1}>MON COMPTE</Typography>
          </Box>
           <Box display="flex" justifyContent="flex-end">
            <Button variant="outlined" sx={{
              color: 'red',
              borderColor: 'red',
              textTransform: 'none',
              '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
            }} startIcon={<Edit />}>
              Modifier mes informations
            </Button>
            <Button variant="outlined" sx={{
              color: 'red',
              borderColor: 'red',
              textTransform: 'none',
              '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              ml: 2
            }} startIcon={<BookmarksIcon />}>
              Adhésion
            </Button>
          </Box>
        </Box>
        

        {/* Content */}
        <Box mt={4}>
        <Grid container spacing={2}>
            {/* QR Code */}
            <Grid item xs={6} display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="body1" fontWeight="bold">QR Code</Typography>
            <Box component="img" src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${userData.ID_User}`} alt="QR Code" width={300} height={300} />
            </Grid>

            {/* User Details */}
            <Grid item xs={6}>
            <Box display="flex" flexDirection="column">
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Société:</Typography>
                <Typography variant="body2" textAlign="center">{societe ? societe.name : 'Non disponible'}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">UID:</Typography>
                <Typography variant="body2" textAlign="center">{userData.Uid || 'Non disponible'}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Matricule:</Typography>
                <Typography variant="body2" textAlign="center">{userData.matricule || 'Non disponible'}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Nom:</Typography>
                <Typography variant="body2" textAlign="center">{userData.name || 'Non disponible'}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Prénom:</Typography>
                <Typography variant="body2" textAlign="center">{userData.prenom || 'Non disponible'}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
            </Box>
            </Grid>

            {/* User Details Bottom - Full Width */}
            <Grid item xs={12}>
            <Box display="flex" flexDirection="column" width="50%">
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Rôle:</Typography>
                <Typography variant="body2" textAlign="center">{userData.role ? userData.role.Role : 'Non disponible'}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Adhérent:</Typography>
                <Typography variant="body2" textAlign="center">{userData.adhesion ? 'Oui' : 'Non'}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Date d'adhésion:</Typography>
                <Typography variant="body2" textAlign="center">{formatDate(userData.date_adhesion)}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Site:</Typography>
                <Typography variant="body2" textAlign="center">{userData.site ? userData.site.name  : 'Non disponible'}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Email:</Typography>
                <Typography variant="body2" textAlign="center">{userData.email || 'Non disponible'}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Téléphone:</Typography>
                <Typography variant="body2" textAlign="center">{userData.telephone || 'Non disponible'}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Adresse:</Typography>
                <Typography variant="body2" textAlign="center">{userData.adresse || 'Non disponible'}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Latitude:</Typography>
                <Typography variant="body2" textAlign="center">{userData.latitude || 'Non disponible'}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Longitude:</Typography>
                <Typography variant="body2" textAlign="center">{userData.longitude || 'Non disponible'}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Nombre de mises à jour:</Typography>
                <Typography variant="body2" textAlign="center">{userData.update_count || '0'}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Statut:</Typography>
                <Typography variant="body2" textAlign="center">{userData.Status || 'Non disponible'}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Date de création:</Typography>
                <Typography variant="body2" textAlign="center">{formatDate(userData.created_at)}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="body1" fontWeight="bold">Dernière mise à jour:</Typography>
                <Typography variant="body2" textAlign="center">{formatDate(userData.updated_at)}</Typography>
                </Box>
            </Box>
            </Grid>
        </Grid>
        </Box>

      </Box>
    </>
  );
}